/**
 * 临时方案，为将react-virtualized的table样式调整为现有table样式
 */

import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { SVG as Svg, SVGProps } from '@binanceus/uikit-core';

const SortDirection = {
    /**
     * Sort items in ascending order.
     * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
     */
    ASC: 'ASC',
  
    /**
     * Sort items in descending order.
     * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
     */
    DESC: 'DESC',
  };

/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
export default function SortIndicator({sortDirection}) {
  const classNames = clsx('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC':
      sortDirection === SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC':
      sortDirection === SortDirection.DESC,
  });

  return ( 
        sortDirection === SortDirection.ASC ? 
        <Svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path opacity={0.5} d="M16 12.85v1.65L12.75 18 9.5 14.5v-1.65H16z" fill="#848E9C" /><path d="M9.5 9.745v-1.65l3.25-3.5 3.25 3.5v1.65H9.5z" fill="url(#sorting-up-color-s24_svg__paint0_linear)" /><defs><linearGradient id="sorting-up-color-s24_svg__paint0_linear" x1={16} y1={4.594} x2={9.5} y2={4.594} gradientUnits="userSpaceOnUse"><stop stopColor="#EFB80B" /><stop offset={1} stopColor="#FBDA3C" /></linearGradient></defs></Svg>
        : <Svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path opacity={0.5} d="M9 10.153V8.5L12.25 5l3.25 3.501v1.652H9z" fill="#848E9C" /><path d="M15.5 13.257v1.652l-3.25 3.5L9 14.91v-1.652h6.5z" fill="url(#sorting-down-color-s24_svg__paint0_linear)" /><defs><linearGradient id="sorting-down-color-s24_svg__paint0_linear" x1={9} y1={18.41} x2={15.5} y2={18.41} gradientUnits="userSpaceOnUse"><stop stopColor="#EFB80B" /><stop offset={1} stopColor="#FBDA3C" /></linearGradient></defs></Svg>

  );
}

SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
};